import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '.';
import { CONTROLLERS } from '../constants';
import { CMS, Response } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CMSService {
  private api: string = CONTROLLERS.CMS;
  constructor(private apiService: ApiService) {}
  getById(cmsId: number): Observable<Response<CMS>> {
    return this.apiService.getById(cmsId.toString(), `${this.api}`);
  }
}
